var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOtMoreThan2H(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: -0.333374,
    cy: -0.166748,
    r: 0.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: -0.166748,
    r: 0.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.33337,
    cy: -0.166748,
    r: 0.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.16663,
    cy: -0.166748,
    r: 0.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: -0.166748,
    r: 0.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.83337,
    cy: -0.166748,
    r: 0.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.6666,
    cy: -0.166748,
    r: 0.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: -0.166748,
    r: 0.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.3334,
    cy: -0.166748,
    r: 0.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -0.333374,
    cy: 1.625,
    r: 0.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.625,
    r: 0.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.33337,
    cy: 1.625,
    r: 0.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.16663,
    cy: 1.625,
    r: 0.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 1.625,
    r: 0.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.83337,
    cy: 1.625,
    r: 0.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.6666,
    cy: 1.625,
    r: 0.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 1.625,
    r: 0.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.3334,
    cy: 1.625,
    r: 0.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -0.333374,
    cy: 3.41675,
    r: 0.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 3.41675,
    r: 0.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.33337,
    cy: 3.41675,
    r: 0.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.16663,
    cy: 3.41675,
    r: 0.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 3.41675,
    r: 0.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.83337,
    cy: 3.41675,
    r: 0.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.6666,
    cy: 3.41675,
    r: 0.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 3.41675,
    r: 0.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.3334,
    cy: 3.41675,
    r: 0.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -0.333374,
    cy: 5.20825,
    r: 0.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 5.20825,
    r: 0.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.33337,
    cy: 5.20825,
    r: 0.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.16663,
    cy: 5.20825,
    r: 0.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 5.20825,
    r: 0.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.83337,
    cy: 5.20825,
    r: 0.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.6666,
    cy: 5.20825,
    r: 0.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 5.20825,
    r: 0.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.3334,
    cy: 5.20825,
    r: 0.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -0.333374,
    cy: 7,
    r: 0.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 7,
    r: 0.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.33337,
    cy: 7,
    r: 0.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.16663,
    cy: 7,
    r: 0.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 0.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.83337,
    cy: 7,
    r: 0.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.6666,
    cy: 7,
    r: 0.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 7,
    r: 0.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.3334,
    cy: 7,
    r: 0.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -0.333374,
    cy: 8.79175,
    r: 0.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 8.79175,
    r: 0.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.33337,
    cy: 8.79175,
    r: 0.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.16663,
    cy: 8.79175,
    r: 0.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 8.79175,
    r: 0.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.83337,
    cy: 8.79175,
    r: 0.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.6666,
    cy: 8.79175,
    r: 0.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 8.79175,
    r: 0.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.3334,
    cy: 8.79175,
    r: 0.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -0.333374,
    cy: 10.5833,
    r: 0.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 10.5833,
    r: 0.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.33337,
    cy: 10.5833,
    r: 0.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.16663,
    cy: 10.5833,
    r: 0.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 10.5833,
    r: 0.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.83337,
    cy: 10.5833,
    r: 0.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.6666,
    cy: 10.5833,
    r: 0.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 10.5833,
    r: 0.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.3334,
    cy: 10.5833,
    r: 0.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -0.333374,
    cy: 12.375,
    r: 0.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 12.375,
    r: 0.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.33337,
    cy: 12.375,
    r: 0.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.16663,
    cy: 12.375,
    r: 0.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 12.375,
    r: 0.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.83337,
    cy: 12.375,
    r: 0.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.6666,
    cy: 12.375,
    r: 0.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.375,
    r: 0.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.3334,
    cy: 12.375,
    r: 0.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -0.333374,
    cy: 14.1667,
    r: 0.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 14.1667,
    r: 0.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.33337,
    cy: 14.1667,
    r: 0.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.16663,
    cy: 14.1667,
    r: 0.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 14.1667,
    r: 0.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.83337,
    cy: 14.1667,
    r: 0.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.6666,
    cy: 14.1667,
    r: 0.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 14.1667,
    r: 0.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.3334,
    cy: 14.1667,
    r: 0.5,
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtMoreThan2H);
export default __webpack_public_path__ + "static/media/ot-more-than-2h.7cf4ab02aa7c5184dd51f12ac0a31d93.svg";
export { ForwardRef as ReactComponent };